import { apiDelete, apiGet, apiPatch, apiPost } from "../fetch";

/** Intros a week an enrolled customer is asked for. */
export type IntroPace = 1 | 2 | 3;

/** A customer enrolled in the intro program (staff only). */
export interface IntroEnrolment {
	id: number;
	user: number;
	name: string;
	company_name: string;
	pace: IntroPace;
	paused: boolean;
	paused_at: string | null;
	enrolled_by: number | null;
	created: string;
}

/** A customer who can still be enrolled. */
export interface IntroCustomer {
	id: number;
	name: string;
	company_name: string;
}

const URL = "/api/v2/intro-enrolments/";

export function fetchIntroEnrolments(): Promise<IntroEnrolment[]> {
	return apiGet(URL) as Promise<IntroEnrolment[]>;
}

export function fetchIntroCandidates(): Promise<IntroCustomer[]> {
	return apiGet(`${URL}candidates/`) as Promise<IntroCustomer[]>;
}

export function enrolIntroCustomer(user: number): Promise<IntroEnrolment> {
	return apiPost(URL, { user }) as Promise<IntroEnrolment>;
}

export function updateIntroEnrolment(
	id: number,
	patch: { pace?: IntroPace; paused?: boolean }
): Promise<IntroEnrolment> {
	return apiPatch(`${URL}${id}/`, patch) as Promise<IntroEnrolment>;
}

export function removeIntroEnrolment(id: number): Promise<unknown> {
	return apiDelete(`${URL}${id}/`);
}

/** The logged-in customer re-paces or pauses their own enrolment (To Do card). */
export function updateMyIntroEnrolment(patch: {
	pace?: IntroPace;
	paused?: boolean;
}): Promise<IntroEnrolment> {
	return apiPatch(`${URL}me/`, patch) as Promise<IntroEnrolment>;
}

export type SentIntroStatus = "sent" | "replied" | "closed" | "converted";

/** One sent intro in the staff Intros table. */
export interface SentIntro {
	id: number;
	lead_name: string;
	lead_url: string | null;
	customer_name: string;
	sent_at: string | null;
	status: SentIntroStatus;
	/** Sent, and still unanswered after the nudge days. */
	needs_nudge: boolean;
	conversation_url: string | null;
}

export function fetchSentIntros(): Promise<SentIntro[]> {
	return apiGet(`${URL}intros/`) as Promise<SentIntro[]>;
}
